<template>
    <section class="live-card space-l" loading="lazy">
        <div class="casino-header-search">
            <input type="text" v-model="searchCasinoString" @keyup="this.searchCasinoMatchesDebounced();" class="form-control" :placeholder="$t('search-casino','Search Casino')"/>
            <span>
                <span class="clear-casino-filter" v-if="searchCasinoString" @click="clearSearch">
                    <i class="fa-solid fa-xmark"></i>
                </span>
                <button class="btn search-casino-cta">
                    <i class="fa-solid fa-magnifying-glass"></i>
                </button>
            </span>
        </div>
        <div class="casino-main-tabs">
            <ul class="nav nav-pills providers" id="pills-tab " role="tablist" v-if="hasMenus && providerList?.length && !searchCasinoResult?.length && !searchCasinoString" ref="providerMenu">
                <li @click="clickOnSelectProvider('All')" class="nav-item" role="presentation">
                    <button class="nav-link" id="pills-all-int-tab" :class="{ 'active': selectedProvider == 'All' }" type="button" aria-selected="true">{{$t('all', 'All')}}</button>
                </li>

                <template v-if="providerList?.length !=0">
                    <li v-for="providerItem in providerList" @click="clickOnSelectProvider(providerItem)" class="nav-item" role="presentation">
                        <button class="nav-link list-menu" :class="{ 'active': selectedProvider == providerItem.provider_name }" id="pills-evolution-tab" data-bs-toggle="pill"
                            data-bs-target="#pills-evolution" type="button" role="tab"
                            aria-controls="pills-evolution" aria-selected="false">
                            <div class="nav-item-btn"><figure><img :src="getImagePath(providerItem?.slug)" alt="" loading="lazy"></figure></div>
                        </button>
                    </li>
                </template>
            </ul>
            <div class="tab-content" id="pills-tabContent">
                <div class="tab-pane fade show active">
                    <div class="all-game-details-page">
                        <ul v-if="!searchCasinoResult?.length && !searchCasinoString && menuList !=null && menuList?.length !=0" class="nav nav-pills casino-menus" id="pills-tab" role="tablist" ref="navMenu">
                            <li v-if="selectedProvider != 'All'" class="nav-item" role="presentation">
                                <button @click="allMenuGames()"  class="nav-link int-all d-block" :class="{ 'active': selectedMenu == 'All'}"  id="pills-all11-tab"
                                    data-bs-toggle="pill" data-bs-target="#pills-all11" type="button"
                                    role="tab" aria-controls="pills-all11" aria-selected="true">
                                    <span>{{$t('all', 'All')}}</span>
                                </button>
                            </li>
                            <li v-for="menuItem in menuList" @click="clickOnMenuItem(menuItem)" class="nav-item"  role="presentation">
                                <button class="nav-link list-menu" :class="{ 'active': selectedMenu?.id == menuItem.id }" id="pills-all11-tab"
                                    data-bs-toggle="pill" data-bs-target="#pills-all11" type="button"
                                    role="tab" aria-controls="pills-all11" aria-selected="true">
                                    <span><img :src="menuItem?.image" alt=""></span>
                                    {{ menuItem.title }}
                                </button>
                            </li>
                        </ul>
                        <div class="tab-content mt-2" id="pills-tabContent">
                            <div v-if="searchCasinoResult?.length" class="tab-pane fade show active" id="pills-search-results" role="tabpanel">
                                <div class="row no-gutters">
                                    <GameItem  v-for="(item, gItemKey) in searchCasinoResult" :key="gItemKey" :gameItem="item"/>
                                </div>
                            </div>
                            <div v-else-if="gamesList?.length && !searchCasinoResult?.length && !searchCasinoString" class="tab-pane fade show active" id="pills-all11" role="tabpanel">
                                <div class="row no-gutters">
                                    <GameItem  v-for="(item, gItemKey) in gamesList" :key="gItemKey" :gameItem="item"/>
                                </div>
                            </div>
                            <div v-else>
                                <div>
                                    <NoDataFound v-if="!globalLoader" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import { defineAsyncComponent } from 'vue';
import loadCasinoGame from '@/shared/services/casinoGamesHandler';
import { CheckEventMangeForCasinoInSearch } from '@/shared/services/eventLocks.js';
import { mapGetters } from 'vuex'

export default {
    name: "Games",
    components: {
        NoDataFound: defineAsyncComponent(() =>
			import('@/shared/components/no-data/NoDataFound.vue')
		),
        GameItem: defineAsyncComponent(() =>
			import('../components/GameItem.vue')
		),
    },
    data() {
        return {
            type: null,
            gamesList:null,
            sectionsList: null,
            menuList: null,
            eventManage: null,
            menuListData: null,
            selectedMenu: 'All',
            providerList: null,
            selectedProvider:'All',
            searchCasinoResult: null,
            searchCasinoString: '',
            routeQuery: this.$route.query,
        }
    },
    computed: {
        hasMenus() {
            return Array.isArray(this.sectionsList) && this.sectionsList.some(item => item.slug === this.type && item.menus);
        },
        ...mapGetters({
            globalLoader: 'globalLoader',
        }),
    },
    created(){
        this.eventManage = this.$store?.getters?.eventManage;
    },
    mounted() {
        this.type = this.$route.params?.type
        this.sectionsList = this.$store?.getters?.gamesData.sections || [];
        this.setGamesList();
    },
    methods: {
        CheckEventMangeForCasinoInSearch,
        loadGame(game) {
            if(!this.$auth.status) {
                this.$helper.showLogin();
                return;
            }
            loadCasinoGame.loadGame(game, this.$auth.user);
        },
        setGamesList() {
            if(this.hasMenus){
                this.menuListData = this.sectionsList.filter(item => item.slug == this.type)[0]?.menus
                this.menuList = this.menuListData
                this.selectedMenu = this.menuList?.[0];
                this.gamesList =  this.selectedMenu?.games;
                this.setProviderList();
            }else{
                this.gamesList =  this.sectionsList.filter(item => item.slug == this.type)[0]?.games
            }
        },
        setProviderList() {
            this.selectedProvider = 'All';
            let providersMap = new Map();
            this.menuList.forEach(menu => {
                menu.games.forEach(game => {
                    const provider = {
                        id: game.provider_id,
                        provider_name: game.provider,
                        slug: game.provider.toLowerCase().replace(/[\s.]+/g, '-').concat('-provider')
                    };
                    providersMap.set(provider.id, provider);
                });
            });
            this.providerList = Array.from(providersMap.values());
            if(this.routeQuery.providerId) {
                this.selectedProvider = this.providerList.find(menu => menu.id == this.routeQuery.providerId);
                if(this.selectedProvider) {
                    this.$nextTick(() => {
                        const providerMenu = this.$refs.providerMenu;
                        if (providerMenu) {
                            this.scrollToActiveTab(providerMenu);
                        }
                    });
                    this.clickOnSelectProvider(this.selectedProvider);
                    this.selectedMenu='All';
                } else {
                    this.selectedProvider = 'All';    
                }
            } else {
                this.selectedProvider = 'All';
            }
            if (this.providerList?.length == 0) {
                this.$errorToast("No Provider Found.");
                // this.$router.push({ name: 'Home' });
            }
        },
        clickOnSelectProvider(item) {
            this.selectedProvider = item;
            if (item == 'All') {
                this.menuList = [...this.menuListData];
                this.selectedMenu = this.menuList[0];
                this.gamesList = this.selectedMenu?.games || [];
            }
            else {
                this.selectedProvider = item.provider_name;
                var filteredMenu = []
                this.menuListData?.forEach((mitem) => {
                    let temp = {...mitem};
                    let filteredData = mitem.games.filter(k => k.provider_id == item.id);
                    if (filteredData?.length) {
                        temp.games = filteredData;
                        filteredMenu.push(temp);
                    }
                })
                this.menuList = filteredMenu;
                this.selectedMenu=this.menuList[0]
                if(this.selectedProvider!='All')
                {
                    this.gamesList = this.menuList.flatMap(item => item.games);
                    this.selectedMenu='All'
                }
                else
                {
                    this.menuList = this.menuListData
                    this.gamesList=this.menuList[0]?.games
                }
            }
        },
        allMenuGames(){
            this.selectedMenu="All"
            if(this.selectedProvider!='All')
            this.gamesList = this.menuList.flatMap(item => item.games);
            else
            this.gamesList=this.menuList[0]?.games
        },
        clickOnMenuItem(item) {
            this.gamesList = null;
            this.gamesList = item?.games;
            this.selectedMenu = item
        },
        clearSearch() {
            this.searchCasinoResult = null;
            this.searchCasinoString = ''
        },
        debounce(callback, timer=1000) {
            const context = this;
            clearTimeout(this.timeoutId);
            this.timeoutId = setTimeout(() => {
                callback.apply(context);
            }, timer);
        },
        searchCasinoMatchesDebounced() {
            this.debounce(function(){
                  this.searchCasinoMatches()
            }, 1000);
        },
        async searchCasinoMatches() {
            if (this.searchCasinoString != '' && this.searchCasinoString?.length > 2) {
                try {
                    this.searchCasinoResult = null;
                    let data = {
                        "search": this.searchCasinoString
                    };
                    this.$store.dispatch('setGlobalLoader', true);
                        this.$apiCall('post', 'SEARCH', data).then(response => {
                            this.$store.dispatch('setGlobalLoader', false);
                            if (response && response.status && response.status == 200) {
                                this.searchCasinoResult = [];
                                let resData = response.data.data.casino ?? [];
                                this.searchCasinoResult = this.CheckEventMangeForCasinoInSearch(resData)                                               
                            } else {
                                this.$errorToast(response.data.debug[0]);
                            }
                        }).catch(error => {
                            this.$store.dispatch('setGlobalLoader', false);
                            if (error) {
                                this.$errorToast(error[0]);
                            }
                        });
                    } catch (error) {
                        this.loading = false;
                    }
            }
            else {
                this.loading = false;
                this.searchCasinoResult = null;
                this.setGamesList('casino');
            }
        },
        scrollToActiveTab(elem) {
            this.$nextTick(() => {
                const navMenu = elem;
                const selectedElement = navMenu?.querySelector('.list-menu.active');
                if (selectedElement) {
                    const currentScrollLeft = navMenu.scrollLeft;

                    const elementRect = selectedElement.getBoundingClientRect();
                    const containerRect = navMenu.getBoundingClientRect();

                    const targetScrollLeft = currentScrollLeft + elementRect.left - containerRect.left - containerRect.width / 2 + elementRect.width / 2 + 20;

                    navMenu.scrollTo({
                        left: targetScrollLeft,
                        behavior: 'smooth',
                    });
                }
            });
        },
        getImagePath(slug) {
            try {
                return require(`@/assets/images/${slug}.webp`);
            } catch (e) {
                console.log(`${slug}`);
                
            }
        },
    }
};
</script>